import { ReactNode } from 'react';
import { Wrapper } from './style';

interface ProjectCardProps {
  children: ReactNode;
}

export function ProjectCard({ children }: ProjectCardProps) {
  return <Wrapper>{children}</Wrapper>;
}
